module.exports = __webpack_public_path__ + "img/inter-milan.f0a6b9b1.png";